import Refresh from '@mui/icons-material/Refresh';
import {
  buttonBaseClasses,
  buttonClasses,
  svgIconClasses,
  useTheme,
} from '@mui/material';
import { SxProps } from '@mui/system';
import { t } from 'i18next';
import { useContext } from 'react';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';

import FilesQueryContext from '../../FilesQueryContext';

interface RefreshCTAProps {
  sx?: SxProps;
}

export default function RefreshCTA({ sx }: RefreshCTAProps) {
  const theme = useTheme();
  const { refresh, fetchReason } = useContext(FilesQueryContext);

  return (
    <SmallButton
      color="inherit"
      disabled={Boolean(fetchReason)}
      onClick={refresh}
      startIcon={<Refresh />}
      variant="outlined"
      sx={{
        [`&.${buttonBaseClasses.root}`]: {
          border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
          pl: 0.5,
          pr: 1,
          py: 0,
          [`.${buttonClasses.startIcon}`]: { ml: 0, mr: 0.5 },
          [`.${svgIconClasses.root}`]: { fontSize: '24px' },
        },
        ...sx,
      }}
    >
      {t('order.new_orders_available')}
    </SmallButton>
  );
}
